import { render, staticRenderFns } from "./CourseLesson.vue?vue&type=template&id=2e54bd92&"
import script from "./CourseLesson.vue?vue&type=script&lang=js&"
export * from "./CourseLesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports